import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';
import { CommonModule } from '@angular/common';
import { ApplicationSubjectLabelPipe } from '../../../../../../../pipes/application-subject-label.pipe';
import { environment } from '../../../../../../../../environments/environment';

@Component({
  selector: 'app-application-data-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule,
    ApplicationSubjectLabelPipe
  ],
  templateUrl: './application-data-preview.component.html'
})
export class ApplicationDataPreviewComponent {

  public application = input<ApplicationAppEntityApplicationRead | null>(null);

  public applicationSubmittedTo = environment.applicationSubmittedTo;

  public showResponsiblePerson: Signal<boolean> = computed(() =>
    !!this.application()?.responsiblePersonEmail?.length
    && !!this.application()?.responsiblePersonFirstName?.length
    && !!this.application()?.responsiblePersonLastName?.length
  );

  public showManager: Signal<boolean> = computed(() =>
    !!this.application()?.managerEmail?.length
    && !!this.application()?.managerFirstName?.length
    && !!this.application()?.managerLastName?.length
  );

  public showRoadTrafficImpact: Signal<boolean> = computed(() => [
    '/zajecie-pasa-prowadzenie-robot',
    '/zajecie-pasa-umieszczenie-obiektow-budowlanych',
    '/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi',
    '/umieszczenie-reklamy',
    '/awaryjne-zajecie-pasa-drogowego',
    '/zajecie-pasa-prawa-wylacznosci'
  ].includes(this.application()?.service?.url || ''));

}
